export const dateJsonSchema = {
  type: 'object',
  properties: {
    orderTotal: {
      type: 'string',
      description: 'OD',
    },
    subTotalPrice: {
      type: 'string',
    },
    taxableAmount: {
      type: 'string',
    },
    totalGiftTaxAmount: {
      type: 'string',
    },
    returnsTotal: {
      type: 'string',
    },
  },
}

export const dateUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/orderTotal',
          component: 'ReadOnlyFieldWithJson',
          label: 'Order Total',
        },
        {
          type: 'Control',
          scope: '#/properties/subTotalPrice',
          component: 'ReadOnlyFieldWithJson',
          label: 'Sub Total Price',
        },
        {
          type: 'Control',
          scope: '#/properties/taxableAmount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Taxable Amount',
        },
      ],
    },
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/totalGiftTaxAmount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Total Gift Tax Amount',
        },
        {
          type: 'Control',
          scope: '#/properties/returnsTotal',
          component: 'ReadOnlyFieldWithJson',
          label: 'Returns Total',
        },
      ],
    },
  ],
}
